import { IDocumentTypeIndexCategory } from "../model/DocumentTypeIndexCategory";
import { ILanguage } from "../../core/model/language/Language";
import OrganisationIndexPresentationModel, {
  TOrganisationIndexPresentationModel
} from "../../organisations/presenter/model/OrganisationIndexPresentationModel";

export interface TDocumentTypeIndexCategoryPresentationModel
  extends IDocumentTypeIndexCategory {
  organisationIndexList: TOrganisationIndexPresentationModel[];
}

const DocumentTypeIndexCategoryPresentationModel = (
  data: IDocumentTypeIndexCategory,
  selectedLanguage: ILanguage
) => {
  const handler: ProxyHandler<IDocumentTypeIndexCategory> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "organisationIndexList":
          return data.organisationIndexList?.map((item) =>
            OrganisationIndexPresentationModel(
              item,
              undefined,
              undefined,
              undefined,
              undefined,
              selectedLanguage
            )
          );

        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "organisationIndexList":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<
    IDocumentTypeIndexCategory,
    TDocumentTypeIndexCategoryPresentationModel
  >(data, handler);
};

export default DocumentTypeIndexCategoryPresentationModel;
